<div class="card">
  <div class="card-body">
    <div class="mb-0">
      <div class="mb-2">
        <div class="row modal-content border border-dark ml-0 mb-4 p-0">
          <div class="col col-md-12">
            <div class="order-header">
              <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3 pt-2">
                <button class="btn-link-back" (click)="goBack()">
                  <i class="mdi mdi-arrow-left"></i>
                  <span>Quay về danh sách</span>
                </button>
                <button
                  class="btn btn-primary btn-sm d-flex align-items-center gap-2"
                  (click)="onUpdate(data, handleOrder)"
                >
                  <i class="mdi mdi-lightning-bolt-outline"></i>
                  <span>Thao tác đơn hàng</span>
                </button>
              </div>
            </div>
            <div class="info-card">
              <div class="info-card-header">
                <span>{{ "Thông tin cửa hàng" | translate }}</span>
              </div>
              <div class="shop-identity d-flex align-items-center gap-3 flex-wrap">
                <div class="shop-icon-circle flex-shrink-0">
                  <img
                    src="../../../assets/images/store.png"
                    class="img-fluid"
                    alt="image"
                  />
                </div>
                <div class="d-flex align-items-center flex-wrap gap-2">
                  <span class="order-code">#{{ data.workspace_code }}</span>
                  <h2 class="order-name mb-0">
                    {{ data.workspace_name | translate }}
                  </h2>
                </div>
              </div>
              <div class="detail-list detail-list--inline">
                <div class="detail-list-item">
                  <i class="mdi mdi-barcode-scan"></i>
                  <div>
                    <span class="info-label">Terminal ID</span>
                    <span class="info-value">{{ data.terminalID || "Chưa có" }}</span>
                  </div>
                </div>
                <div class="detail-list-item">
                  <i class="mdi mdi-account-outline"></i>
                  <div>
                    <span class="info-label">Thông tin khách hàng</span>
                    <span class="info-value">{{ data.user_phone }} - {{ data.full_name }}</span>
                  </div>
                </div>
                <div class="detail-list-item">
                  <i class="mdi mdi-bank-outline"></i>
                  <div>
                    <span class="info-label">Thông tin tài khoản</span>
                    <span class="info-value">
                      {{ data.terminal_bank_acc || "Chưa có" }}
                      <ng-container *ngIf="data.terminal_bank_acc_name">
                        - {{ data.terminal_bank_acc_name }}
                      </ng-container>
                    </span>
                  </div>
                </div>
                <div class="detail-list-item">
                  <i class="mdi mdi-domain"></i>
                  <div>
                    <span class="info-label">Loại cửa hàng</span>
                    <span
                      class="badge font-size-12"
                      [ngClass]="getCustomerTypeClass(data.customer_type)"
                    >
                      {{ getCustomerTypeLabel(data.customer_type) }}
                    </span>
                  </div>
                </div>
                <div class="detail-list-item">
                  <i class="mdi mdi-calendar-check-outline"></i>
                  <div>
                    <span class="info-label">Ngày tạo</span>
                    <span class="info-value">
                      {{ data.workspace_created_at | date : "dd/MM/yyyy" }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="detail-row">
              <div class="info-card">
                <div class="info-card-header">
                  <i class="mdi mdi-speaker"></i>
                  <span>Thông tin đơn hàng</span>
                </div>
                <div class="d-flex gap-3 align-items-start flex-wrap">
                  <div class="product-icon flex-shrink-0">
                    <i
                      class="mdi"
                      [ngClass]="{
                        'mdi-signal-cellular-3': data.device_name === 'Loa 4G',
                        'mdi-wifi': data.device_name === 'Loa WIFI',
                        'mdi-speaker-wireless':
                          data.device_name !== 'Loa 4G' &&
                          data.device_name !== 'Loa WIFI'
                      }"
                    ></i>
                  </div>
                  <div class="flex-grow-1 product-info">
                    <h3 class="product-name">
                      {{ serviceTypeMap[data.service_package_type] || "Đơn thường" }}
                    </h3>
                    <div class="product-badges d-flex flex-wrap align-items-center gap-2">
                      <span
                        class="badge font-size-12"
                        [ngClass]="{
                          'badge-info': data.device_name === 'Loa 4G',
                          'badge-primary': data.device_name === 'Loa WIFI',
                          'badge-dark': data.device_name === 'Loa 4G+WIFI',
                          'badge-secondary':
                            data.device_name !== 'Loa 4G' &&
                            data.device_name !== 'Loa WIFI' &&
                            data.device_name !== 'Loa 4G+WIFI'
                        }"
                      >
                        {{ data.device_name || "--" }} x {{ data.quantity || 1 }}
                      </span>
                      <span
                        class="badge font-size-12"
                        *ngIf="data.original_duration"
                        [ngClass]="{
                          'badge-secondary': data.original_duration == 3,
                          'badge-info': data.original_duration == 6,
                          'badge-warning': data.original_duration == 12,
                          'badge-success': data.original_duration == 60,
                          'badge-dark':
                            data.original_duration != 3 &&
                            data.original_duration != 6 &&
                            data.original_duration != 12 &&
                            data.original_duration != 60
                        }"
                      >
                        Gói {{ data.original_duration }} tháng
                      </span>
                      <span class="product-code" *ngIf="data.referrer">
                        <i class="mdi mdi-pound"></i>Mã giới thiệu: {{ data.referrer }}
                      </span>
                    </div>
                    <div class="product-benefit" *ngIf="data.benefit">
                      <i class="mdi mdi-shield-check-outline"></i>
                      {{ data.benefit }}
                    </div>
                  </div>
                  <div class="price-block flex-shrink-0 ms-auto text-end">
                    <p
                      class="price-original"
                      *ngIf="data.original_price && data.original_price !== data.discounted_price"
                    >
                      {{ data.original_price | number : "1.0-0" }}<sup>đ</sup>
                    </p>
                    <p class="price-discounted">
                      {{ data.discounted_price | number : "1.0-0" }}<sup>đ</sup>
                    </p>
                    <span class="discount-pill" *ngIf="getDiscountPercent() > 0">
                      -{{ getDiscountPercent() }}%
                    </span>
                  </div>
                </div>
                <div class="order-extra-info d-flex flex-wrap gap-4">
                  <span class="meta-item">
                    <i class="mdi mdi-calendar-arrow-right"></i>
                    Ngày mua:
                    <b>{{ data.created_at | date : "dd/MM/yyyy HH:mm" }}</b>
                  </span>
                  <span class="meta-item">
                    <i class="mdi mdi-headset"></i>
                    CSKH: <b>{{ getCsTakeCare(data) }}</b>
                  </span>
                </div>
                <div class="transaction-box" *ngIf="mb_reference_number">
                  <span>Mã giao dịch: <b>{{ mb_reference_number }}</b></span>
                  <button
                    [cdkCopyToClipboard]="mb_reference_number"
                    class="btn btn-sm btn-primary"
                  >
                    <i class="mdi mdi-content-copy"></i>
                  </button>
                </div>
                <div
                  class="cancel-request-info"
                  *ngIf="data.oc_requested_cancel_date || data.oc_reason"
                >
                  <div
                    class="meta-item"
                    *ngIf="data.oc_requested_cancel_date"
                  >
                    <i class="mdi mdi-calendar-remove-outline"></i>
                    Ngày yêu cầu hủy:
                    <b>
                      {{ data.oc_requested_cancel_date | date : "dd/MM/yyyy" }}
                    </b>
                  </div>
                  <div class="meta-item" *ngIf="data.oc_reason">
                    <i class="mdi mdi-alert-circle-outline"></i>
                    Lý do hủy: <b>{{ data.oc_reason }}</b>
                  </div>
                </div>
                <div class="rm-info-box" *ngIf="data?.rm_info">
                  <div class="rm-info-line" *ngIf="buildRmInfoLine(data?.rm_info)">
                    RM: <b>{{ buildRmInfoLine(data?.rm_info) }}</b>
                  </div>
                  <div class="rm-agency-line" *ngIf="buildRmAgencyLine(data?.rm_info)">
                    {{ buildRmAgencyLine(data?.rm_info) }}
                  </div>
                </div>
              </div>
              <div class="info-card">
                <div class="info-card-header d-flex justify-content-between align-items-center flex-wrap gap-2">
                  <span>
                    <i class="mdi mdi-map-marker-outline"></i>
                    {{ "Thông tin giao hàng" | translate }}
                  </span>
                  <button
                    *ngIf="data.delivery_method == 'shipper'"
                    class="btn btn-outline-primary btn-sm"
                    (click)="onDetailHistory(data, detailOrder)"
                  >
                    Chi tiết giao hàng
                  </button>
                </div>
                <div class="detail-list detail-list--row">
                  <div class="detail-list-item">
                    <i class="mdi mdi-check-circle-outline"></i>
                    <div>
                      <span class="info-label">Trạng thái: </span>
                      <span
                        class="info-value status-text"
                        [ngClass]="orderStatusClass(data.status)"
                      >
                        {{ data.status }}
                      </span>
                    </div>
                  </div>
                  <div class="detail-list-item">
                    <i class="mdi mdi-map-marker-outline"></i>
                    <div>
                      <span class="info-label">Địa chỉ: </span>
                      <span class="info-value" *ngIf="data.delivery_method == 'shipper'">
                        {{ buildShipperAddress(data) || "Chưa có" }}
                      </span>
                      <span class="info-value" *ngIf="data.delivery_method == 'direct'">
                        {{ buildDirectAddress(data) || "Chưa có" }}
                      </span>
                    </div>
                  </div>
                  <div class="detail-list-item">
                    <i class="mdi mdi-account-outline"></i>
                    <div>
                      <span class="info-label">Người nhận: </span>
                      <span class="info-value" *ngIf="data.delivery_method == 'shipper'">
                        {{ data.customer_name }}
                      </span>
                      <span class="info-value" *ngIf="data.delivery_method == 'direct'">
                        {{ data.full_name }}
                      </span>
                    </div>
                  </div>
                  <div class="detail-list-item">
                    <i class="mdi mdi-phone-outline"></i>
                    <div>
                      <span class="info-label">Số điện thoại: </span>
                      <span class="info-value" *ngIf="data.delivery_method == 'shipper'">
                        {{ formatPhoneDisplay(data.phone) }}
                      </span>
                      <span class="info-value" *ngIf="data.delivery_method == 'direct'">
                        {{ formatPhoneDisplay(data.user_phone) }}
                      </span>
                    </div>
                  </div>
                  <div
                    class="detail-list-item"
                    *ngIf="data.delivery_method == 'shipper' && data.order_code"
                  >
                    <i class="mdi mdi-barcode"></i>
                    <div>
                      <span class="info-label">Mã vận đơn: </span>
                      <span class="info-value">{{ data.order_code }}</span>
                    </div>
                  </div>
                  <div
                    class="detail-list-item"
                    *ngIf="data.delivery_method == 'shipper' && data.ghn_sent_date"
                  >
                    <i class="mdi mdi-send-outline"></i>
                    <div>
                      <span class="info-label">Ngày gửi ĐVVC: </span>
                      <span class="info-value">{{ data.ghn_sent_date }}</span>
                    </div>
                  </div>
                  <div
                    class="detail-list-item"
                    *ngIf="data.delivery_method == 'shipper' && data.delivery_date"
                  >
                    <i class="mdi mdi-package-variant-closed"></i>
                    <div>
                      <span class="info-label">Ngày giao thành công: </span>
                      <span class="info-value">{{ data.delivery_date }}</span>
                    </div>
                  </div>
                </div>
                <div class="mini-stats" *ngIf="data.delivery_method == 'shipper'">
                  <div class="mini-stat">
                    <p class="mini-stat-label">Đơn vị giao hàng</p>
                    <p class="mini-stat-value">{{ data.shipping_unit }}</p>
                  </div>
                  <div class="mini-stat">
                    <p class="mini-stat-label">Thời gian dự kiến</p>
                    <p class="mini-stat-value">
                      {{ data.expected_delivery_time || "Chưa có" }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="info-card">
          <div class="info-card-header info-card-header--bar d-flex align-items-center justify-content-between">
            <span>
              <i class="mdi mdi-speaker-multiple"></i>
              Danh sách thiết bị
            </span>
            <button
              type="button"
              class="btn btn-link btn-sm text-white p-0"
              (click)="showOrderDeviceLinkHistory(contentOrderDeviceLinkHistory)"
            >
              <i class="mdi mdi-history"></i>
              Lịch sử liên kết thiết bị
            </button>
          </div>
          <div class="table-responsive">
            <table
              id="basic-datatable"
              class="table table-bordered dt-responsive nowrap no-footer dtr-inline table-modern"
            >
              <thead>
                <tr class="text-center bg-table">
                  <th>{{ "#" | translate }}</th>
                  <th>{{ "Mã thiết bị" | translate }}</th>
                  <th>{{ "Model" | translate }}</th>
                  <th>{{ "Nhà mạng" | translate }}</th>
                  <th>{{ "Mã sim" | translate }}</th>
                  <th>{{ "Trạng thái" | translate }}</th>
                  <th>{{ "Kết nối" | translate }}</th>
                  <th>{{ "Ngày kích hoạt" | translate }}</th>
                  <th>{{ "Ngày hết hạn" | translate }}</th>
                  <th>{{ "Ngày gia hạn gần nhất" | translate }}</th>
                  <th>{{ "Thao tác" | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="text-center"
                  *ngFor="let data2 of listDataDevice; let i = index"
                >
                  <td>{{ pageSize * (pageIndex - 1) + i + 1 }}</td>

                  <td
                    class="hyperlink"
                    (click)="onRenewHistory(data2, renewHistory)"
                  >
                    {{ data2.serial_number }}
                  </td>
                  <td>{{ data2.model }}</td>
                  <td>{{ data2.network_provider }}</td>
                  <td>{{ data2.sim4g_imsi }}</td>
                  <td>
                    <span
                      class="status-pill status-pill--sm"
                      [ngClass]="{
                        'status-pill--danger': data2.status === 'Inactive',
                        'status-pill--success': data2.status === 'Active',
                        'status-pill--secondary': data2.status === 'Expired'
                      }"
                    >
                      {{ data2.status }}
                    </span>
                  </td>
                  <td>
                    <span
                      class="status-pill status-pill--sm"
                      [ngClass]="{
                        'status-pill--danger': data2.connectedStatus === 'Disconnected',
                        'status-pill--success': data2.connectedStatus === 'Connected'
                      }"
                    >
                      {{ data2.connectedStatus }}
                    </span>
                  </td>
                  <td>{{ data2.activation_date | date : "dd/MM/yyyy" }}</td>
                  <td>{{ data2.expiration_date | date : "dd/MM/yyyy" }}</td>
                  <td>{{ data2.last_renewal_date | date : "dd/MM/yyyy" }}</td>
                  <td>
                    <div ngbDropdown container="body" class="d-inline-block">
                      <button
                        type="button"
                        class="device-action-trigger"
                        ngbDropdownToggle
                      >
                      </button>
                      <div ngbDropdownMenu class="device-action-menu">
                        <button
                          type="button"
                          ngbDropdownItem
                          (click)="onEdit(data2, contentQR)"
                        >
                          <i class="mdi mdi-qrcode-scan text-success"></i>
                          {{ "Hiển thị QR" | translate }}
                        </button>
                        <button
                          type="button"
                          ngbDropdownItem
                          (click)="showDeviceLinkHistory(data2, contentDeviceLinkHistory)"
                        >
                          <i class="mdi mdi-history text-primary"></i>
                          Lịch sử liên kết
                        </button>
                        <button
                          type="button"
                          ngbDropdownItem
                          (click)="onChange(data2, contentLink)"
                        >
                          <i class="mdi mdi-bell-outline text-info"></i>
                          {{ "Gửi thông báo" | translate }}
                        </button>
                        <button
                          type="button"
                          ngbDropdownItem
                          (click)="onSearchTransaction(data2, contentSearch)"
                        >
                          <i class="mdi mdi-file-search-outline text-secondary"></i>
                          {{ "Tra cứu giao dịch" | translate }}
                        </button>
                        <button
                          type="button"
                          ngbDropdownItem
                          (click)="onChange(data2, contentChangeDevice)"
                        >
                          <i class="mdi mdi-swap-horizontal text-primary"></i>
                          {{ "Đổi thiết bị" | translate }}
                        </button>
                        <button
                          type="button"
                          *ngIf="
                            role == 'admin' ||
                            role == 'delivery' ||
                            role == 'customer service'
                          "
                          ngbDropdownItem
                          (click)="onChange(data2, contentCancelDevice)"
                        >
                          <i class="mdi mdi-close-circle-outline text-danger"></i>
                          {{ "Huỷ liên kết" | translate }}
                        </button>
                        <button
                          type="button"
                          ngbDropdownItem
                          (click)="onMarkDeviceIssue(data2, contentMarkIssue)"
                        >
                          <i class="mdi mdi-alert-outline text-warning"></i>
                          {{ "Đánh dấu mất/hỏng loa" | translate }}
                        </button>
                        <button
                          type="button"
                          *ngIf="
                            data2.model === '4G' || data2.model === '4G+WIFI'
                          "
                          ngbDropdownItem
                          (click)="onChange(data2, changeSimcard)"
                        >
                          <i class="mdi mdi-sim text-warning"></i>
                          {{ "Thay đổi mã SIM" | translate }}
                        </button>
                        <button
                          type="button"
                          ngbDropdownItem
                          (click)="onChange(data2, cumulativeServicePackage)"
                        >
                          <i class="mdi mdi-plus-circle-outline text-info"></i>
                          {{ "Cộng dồn gói dịch vụ" | translate }}
                        </button>
                        <button
                          type="button"
                          *ngIf="
                            order_type === 'separate' || order_type === 'merge'
                          "
                          ngbDropdownItem
                          (click)="onSubtractTime(data2)"
                        >
                          <i class="mdi mdi-minus-circle-outline text-secondary"></i>
                          {{ "Trừ thời hạn gói dịch vụ" | translate }}
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="info-card">
          <div class="info-card-header info-card-header--bar">
            <i class="mdi mdi-history"></i>
            <span>Lịch sử thao tác</span>
          </div>
          <div class="log-timeline-header" *ngIf="listDataLog?.length">
            <span class="log-timeline-header-spacer"></span>
            <div class="log-timeline-header-cols">
              <span>Thao tác</span>
              <span>Ghi chú</span>
              <span>Thời gian</span>
            </div>
          </div>
          <div class="log-timeline">
            <div
              class="log-timeline-item"
              *ngFor="let data2 of listDataLog; let last = last"
              [class.is-last]="last"
            >
              <div class="log-timeline-dot">
                <i class="mdi mdi-swap-horizontal"></i>
              </div>
              <div class="log-timeline-content">
                <div class="log-timeline-main">
                  <p class="log-action">{{ data2.action }}</p>
                  <p class="log-actor">{{ data2.full_name }}</p>
                </div>
                <div class="log-note-col">
                  <div class="log-diff-list" *ngIf="data2.noteDiffs; else plainNote">
                    <div class="log-diff-item" *ngFor="let d of data2.noteDiffs">
                      <span class="log-diff-label">{{ d.label || d.field }}:</span>
                      <span class="log-diff-old">{{ d.old || "--" }}</span>
                      <i class="mdi mdi-arrow-right"></i>
                      <span class="log-diff-new">{{ d.new || "--" }}</span>
                    </div>
                  </div>
                  <ng-template #plainNote>
                    <span class="log-note" *ngIf="data2.note">{{ data2.note }}</span>
                    <span class="log-note-empty" *ngIf="!data2.note">--</span>
                  </ng-template>
                  <button
                    *ngIf="hasRecallEvidence(data2)"
                    type="button"
                    class="btn btn-outline-primary btn-sm d-block mt-1"
                    (click)="showDeviceRecallEvidence(data2, contentDeviceRecallEvidence)"
                  >
                    <i class="mdi mdi-file-image-outline"></i>
                    Xem minh chứng thu hồi
                  </button>
                </div>
                <div class="log-time" *ngIf="formatLogDateTime(data2.datetime) as t">
                  <span class="log-date">{{ t.date }}</span>
                  <span class="log-clock">{{ t.time }}</span>
                </div>
              </div>
            </div>
            <div
              *ngIf="!listDataLog || listDataLog.length === 0"
              class="text-center text-muted py-3"
            >
              Chưa có dữ liệu
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #changeToOnline role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">
      {{ "Cập nhật thông tin giao hàng" | translate }}
    </h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="onChangeShip()" [formGroup]="formData">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Tên người nhận" | translate
            }}</label>
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="recipient_name"
                [ngClass]="{
                  'is-invalid': submitted && form.recipient_name.errors
                }"
              />
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Số điện thoại" | translate
            }}</label>
            <div class="col-md-10">
              <input
                type="phone"
                class="form-control"
                formControlName="phone_number"
                [ngClass]="{
                  'is-invalid': submitted && form.phone_number.errors
                }"
              />
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Thành phố/Tỉnh" | translate
            }}</label>
            <div class="col-md-10">
              <ng-select
                [items]="listProvince"
                bindLabel="PROVINCE_NAME"
                (change)="onProvinceChange($event)"
                formControlName="province"
                placeholder="{{ 'Chọn thành phố/tỉnh' | translate }}"
                [ngClass]="{ 'is-invalid': submitted && form.province.errors }"
              >
              </ng-select>
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Quận/Huyện" | translate
            }}</label>
            <div class="col-md-10">
              <ng-select
                [items]="listDistrict"
                bindLabel="DISTRICT_NAME"
                (change)="onDistrictChange($event)"
                formControlName="district"
                placeholder="{{ 'Chọn quận/huyện' | translate }}"
                [ngClass]="{ 'is-invalid': submitted && form.district.errors }"
              >
              </ng-select>
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Phường/Xã" | translate
            }}</label>
            <div class="col-md-10">
              <ng-select
                [items]="listWard"
                bindLabel="WARDS_NAME"
                formControlName="ward"
                placeholder="{{ 'Chọn phường/xã' | translate }}"
                [ngClass]="{ 'is-invalid': submitted && form.ward.errors }"
              >
              </ng-select>
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Địa chỉ cụ thể" | translate
            }}</label>
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="specific_address"
                [ngClass]="{
                  'is-invalid': submitted && form.specific_address.errors
                }"
              />
            </div>
          </div>
        </div>

        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            type="submit"
            class="btn btn-success btn-lg"
            style="width: 150px"
            [disabled]="submitted && formData.invalid"
          >
            {{ "Cập nhật" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #contentDeviceRecallEvidence role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Minh chứng thu hồi thiết bị</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="recall-evidence-details">
      <div>
        <span class="text-muted">Mã thiết bị</span>
        <strong>{{ deviceRecallEvidenceSerial }}</strong>
      </div>
      <div>
        <span class="text-muted">Ngày nhận hàng hoàn</span>
        <strong>{{ deviceRecallEvidence?.returnedDate | date : 'dd/MM/yyyy' }}</strong>
      </div>
      <div>
        <span class="text-muted">Phân loại thiết bị</span>
        <strong>{{ getReuseCategoryLabel(deviceRecallEvidence?.reuseCategory) }}</strong>
      </div>
      <div>
        <span class="text-muted">Lý do phân loại</span>
        <strong>{{ deviceRecallEvidence?.reuseCategoryReason || '--' }}</strong>
      </div>
      <div *ngIf="deviceRecallEvidence?.createdBy">
        <span class="text-muted">Người tạo</span>
        <strong>{{ deviceRecallEvidence.createdBy.fullName || '--' }}</strong>
      </div>
    </div>

    <div class="recall-evidence-grid" *ngIf="deviceRecallEvidence?.evidences?.length; else noRecallEvidence">
      <div class="recall-evidence-item" *ngFor="let evidence of deviceRecallEvidence.evidences">
        <ng-container [ngSwitch]="evidence.fileType">
          <img
            *ngSwitchCase="'IMAGE'"
            [src]="getRecallEvidenceMediaUrl(evidence)"
            [alt]="'Minh chứng ảnh ' + deviceRecallEvidenceSerial"
            (error)="onRecallEvidenceMediaError(evidence, $event)"
            (click)="openRecallEvidenceImagePreview(evidence, contentRecallEvidenceImagePreview)"
          />
          <video
            *ngSwitchCase="'VIDEO'"
            controls
            preload="metadata"
            (error)="onRecallEvidenceMediaError(evidence, $event)"
          >
            <source [src]="getRecallEvidenceMediaUrl(evidence)" [type]="evidence.mimeType" />
            Trình duyệt không hỗ trợ phát video.
          </video>
          <a
            class="btn btn-outline-primary"
            *ngSwitchDefault
            [href]="getRecallEvidenceMediaUrl(evidence)"
            target="_blank"
            rel="noopener"
          >
            Tải minh chứng
          </a>
        </ng-container>
        <a
          class="recall-evidence-download"
          [href]="getRecallEvidenceMediaUrl(evidence)"
          target="_blank"
          rel="noopener"
        >
          <i class="mdi mdi-download"></i>
          Tải xuống
        </a>
      </div>
    </div>
    <ng-template #noRecallEvidence>
      <p class="text-center text-muted py-4 mb-0">Chưa có tệp minh chứng thu hồi.</p>
    </ng-template>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal('close click')">Đóng</button>
  </div>
</ng-template>

<ng-template #contentRecallEvidenceImagePreview role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Xem ảnh minh chứng</h5>
    <div class="d-flex align-items-center gap-2">
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="changeRecallEvidenceZoom(-0.25)">
        <i class="mdi mdi-magnify-minus-outline"></i>
      </button>
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="resetRecallEvidenceZoom()">
        {{ recallEvidenceZoom * 100 | number : '1.0-0' }}%
      </button>
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="changeRecallEvidenceZoom(0.25)">
        <i class="mdi mdi-magnify-plus-outline"></i>
      </button>
      <button type="button" class="close ml-2" aria-label="Close" (click)="modal('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
  <div class="modal-body recall-evidence-preview-body">
    <img
      *ngIf="recallEvidencePreviewUrl"
      class="recall-evidence-preview-image"
      [src]="recallEvidencePreviewUrl"
      [style.transform]="'scale(' + recallEvidenceZoom + ')'"
      alt="Ảnh minh chứng thu hồi thiết bị"
    />
  </div>
</ng-template>

<ng-template #contentOrderDeviceLinkHistory role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Lịch sử liên kết thiết bị</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="table-responsive">
      <table class="table table-bordered table-hover mb-0">
        <thead class="thead-light">
          <tr>
            <th>#</th>
            <th>Mã thiết bị</th>
            <th>Trạng thái</th>
            <th>Ngày liên kết</th>
            <th>Ngày huỷ liên kết</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let history of orderDeviceLinkHistory; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ history.serial_number || '--' }}</td>
            <td>
              <span
                class="badge"
                [ngClass]="history.device_is_deleted == 1 ? 'badge-danger' : 'badge-success'"
              >
                {{ history.device_is_deleted == 1 ? 'Đã huỷ liên kết' : 'Đang liên kết' }}
              </span>
            </td>
            <td>{{ (history.device_subscription_created_at || history.device_created_at) | date : 'dd/MM/yyyy HH:mm' }}</td>
            <td>{{ history.cancel_date ? (history.cancel_date | date : 'dd/MM/yyyy HH:mm') : '--' }}</td>
          </tr>
          <tr *ngIf="!orderDeviceLinkHistory.length">
            <td colspan="5" class="text-center text-muted py-4">
              Chưa có lịch sử liên kết thiết bị cho đơn hàng này.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal('close click')">Đóng</button>
  </div>
</ng-template>

<ng-template #contentDeviceLinkHistory role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Lịch sử liên kết thiết bị</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <p class="mb-3 text-muted">
      Thiết bị: <strong>{{ deviceLinkHistorySerial }}</strong>
    </p>
    <div class="table-responsive">
      <table class="table table-bordered table-hover mb-0">
        <thead class="thead-light">
          <tr>
            <th>#</th>
            <th>Mã đơn hàng</th>
            <th>Số điện thoại KH</th>
            <th>Họ tên KH</th>
            <th>Trạng thái</th>
            <th>Ngày liên kết</th>
            <th>Ngày huỷ liên kết</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let history of deviceLinkHistory; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ history.customer_order_id || '--' }}</td>
            <td>{{ history.user_phone || '--' }}</td>
            <td>{{ history.user_full_name || '--' }}</td>
            <td>
              <span
                class="badge"
                [ngClass]="history.device_is_deleted == 1 ? 'badge-danger' : 'badge-success'"
              >
                {{ history.device_is_deleted == 1 ? 'Đã huỷ liên kết' : 'Đang liên kết' }}
              </span>
            </td>
            <td>{{ history.device_created_at | date : 'dd/MM/yyyy HH:mm' }}</td>
            <td>
              <ng-container *ngIf="history.device_is_deleted == 1; else noCancelDate">
                {{ history.device_updated_at | date : 'dd/MM/yyyy HH:mm' }}
              </ng-container>
              <ng-template #noCancelDate>--</ng-template>
            </td>
          </tr>
          <tr *ngIf="!deviceLinkHistory.length">
            <td colspan="7" class="text-center text-muted py-4">
              Chưa có lịch sử liên kết cho thiết bị này.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal('close click')">Đóng</button>
  </div>
</ng-template>

<ng-template #contentChangeDevice role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">
      {{ "Thay đổi thiết bị" | translate }}
    </h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="deviceChange()" [formGroup]="formData">
        <div class="row">
          <!-- Thiết bị -->
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Thiết bị" | translate
            }}</label>
            <div class="col-md-10">
              <input
                disabled
                type="text"
                class="form-control"
                formControlName="serial_number"
                [ngClass]="{
                  'is-invalid': submitted && form.serial_number.errors
                }"
              />
            </div>
          </div>

          <!-- Thiết bị mới -->

          <!-- Thiết bị mới -->
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Thiết bị mới" | translate
            }}</label>
            <div class="col-md-10">
              <ng-select
                [items]="listDeviceLink"
                bindLabel="serial_number"
                bindValue="serial_number"
                formControlName="serial_number_new"
                (search)="onSearchChange($event)"
                placeholder="{{ 'Chọn thiết bị mới' | translate }}"
                [ngClass]="{
                  'is-invalid': submitted && form.serial_number_new.errors
                }"
              >
              </ng-select>
            </div>
          </div>

          <!-- Lý do thay đổi -->
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Lý do" | translate
            }}</label>
            <div class="col-md-10">
              <ng-select
                [items]="reasonOptions"
                bindLabel="label"
                bindValue="value"
                formControlName="reason"
                placeholder="{{ 'Chọn lý do' | translate }}"
                [ngClass]="{
                  'is-invalid': submitted && form.reason.errors
                }"
              >
              </ng-select>
            </div>
          </div>

          <!-- Ghi chú -->
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label">{{
              "Ghi chú" | translate
            }}</label>
            <div class="col-md-10">
              <textarea
                class="form-control"
                rows="3"
                formControlName="note"
                placeholder="{{ 'Nhập ghi chú (nếu có)' | translate }}"
              ></textarea>
            </div>
          </div>
        </div>

        <!-- Nút hành động -->
        <div class="text-center mt-3"></div>

        <!-- Nút hành động -->
        <div class="text-center mt-3">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            type="submit"
            class="btn btn-success btn-lg"
            style="width: 150px"
            [disabled]="
              !formData.get('serial_number')?.value ||
              !formData.get('serial_number_new')?.value ||
              !formData.get('reason')?.value
            "
          >
            {{ "Lưu" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #updatecontent role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Cập nhật cuộc gọi</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="updateOrder()" [formGroup]="formData">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-5 col-form-label required_label">{{
              "Hành động" | translate
            }}</label>
            <div class="col-12">
              <select
                class="form-select"
                aria-label="Default select example"
                class="form-control"
                formControlName="typeUpdate"
                [ngClass]="{
                  'is-invalid': submitted && form.typeUpdate.errors
                }"
              >
                <option value="{{ item.value }}" *ngFor="let item of typePhone">
                  {{ item.label }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-md-5 col-form-label required_label">{{
              "Ghi chú" | translate
            }}</label>
            <div class="col-md-12">
              <textarea
                placeholder="Nhập ghi chú"
                class="form-control"
                formControlName="note"
                [ngClass]="{ 'is-invalid': submitted && form.note.errors }"
                rows="3"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            type="submit"
            class="btn btn-primary btn-lg"
            style="width: 150px"
          >
            {{ "Cập nhật" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #updateCSKH role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Cập nhật CSKH hỗ trợ</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="updateOrderCSKH()" [formGroup]="formData">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-5 col-form-label required_label">
              {{ "Chọn CSKH" | translate }}
            </label>

            <div class="col-12">
              <ng-select
                [searchable]="true"
                [items]="customerServices"
                bindLabel="full_name"
                bindValue="id"
                [multiple]="true"
                [closeOnSelect]="false"
                placeholder="Chọn CSKH"
                formControlName="cs_take_care"
                [ngClass]="{
                  'is-invalid': submitted && form.cs_take_care.errors
                }"
              >
              </ng-select>
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-5 col-form-label required_label">
              {{ "Ghi chú" | translate }}
            </label>

            <div class="col-md-12">
              <textarea
                placeholder="Nhập ghi chú"
                class="form-control"
                formControlName="note"
                [ngClass]="{
                  'is-invalid': submitted && form.note.errors
                }"
                rows="3"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>

          <button
            type="submit"
            class="btn btn-primary btn-lg"
            style="width: 150px"
          >
            {{ "Cập nhật" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #updateOrderDelivered role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Cập nhật Đã giao hàng</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="updateDelivered()" [formGroup]="formData">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-5 col-form-label required_label">{{
              "Đơn vị vận chuyển" | translate
            }}</label>
            <div class="col-12">
              <select
                class="form-select"
                aria-label="Default select example"
                class="form-control"
                formControlName="shipNote"
                [ngClass]="{ 'is-invalid': submitted && form.shipNote.errors }"
              >
                <option
                  value="{{ item.value }}"
                  *ngFor="let item of typeUnitDone"
                >
                  {{ item.label }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-md-5 col-form-label required_label">{{
              "Ngày gửi hàng" | translate
            }}</label>
            <div class="col-md-12">
              <input
                type="date"
                class="form-control"
                formControlName="shipDate"
                [ngClass]="{
                  'is-invalid': submitted && form.shipDate.errors
                }"
              />
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-md-5 col-form-label required_label">{{
              "Ngày giao hàng thành công" | translate
            }}</label>
            <div class="col-md-12">
              <input
                type="date"
                class="form-control"
                formControlName="deliveredDate"
                [min]="getMinDeliveredDate()"
                [ngClass]="{
                  'is-invalid': submitted && form.deliveredDate.errors
                }"
              />
            </div>
          </div>
          <div
            class="form-group row col-md-12"
            *ngIf="formData.value.shipNote === 'Viettel post'"
          >
            <label class="col-md-5 col-form-label required_label">{{
              "Mã vận đơn" | translate
            }}</label>
            <div class="col-md-12">
              <input
                type="text"
                placeholder="Nhập mã vận đơn"
                class="form-control"
                formControlName="orderCode"
                [ngClass]="{ 'is-invalid': submitted && form.orderCode.errors }"
              />
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-md-5 col-form-label">{{
              "Ghi chú" | translate
            }}</label>
            <div class="col-md-12">
              <textarea
                placeholder="Nhập ghi chú"
                class="form-control"
                formControlName="note"
                rows="3"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            [disabled]="
              !formData.value.shipNote ||
              !formData.value.shipDate ||
              !formData.value.deliveredDate ||
              (formData.value.shipNote === 'Viettel post' &&
                !formData.value.orderCode) ||
              isDeliveryDateInvalid()
            "
            type="submit"
            class="btn btn-primary btn-lg"
            style="width: 150px"
          >
            {{ "Cập nhật" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #updateOrderCode role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Cập nhật mã vận đơn</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="updateCodeShip()" [formGroup]="formData">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-5 col-form-label required_label">{{
              "Đơn vị giao" | translate
            }}</label>
            <div class="col-12">
              <select
                class="form-select"
                aria-label="Default select example"
                class="form-control"
                formControlName="shipNote"
                [ngClass]="{ 'is-invalid': submitted && form.shipNote.errors }"
              >
                <option value="{{ item.value }}" *ngFor="let item of typeUnit">
                  {{ item.label }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-5 col-form-label required_label">{{
              "Mã đơn mới" | translate
            }}</label>
            <div class="col-12">
              <input
                type="text"
                class="form-control"
                formControlName="orderCode"
                [ngClass]="{ 'is-invalid': submitted && form.phone.errors }"
                [(ngModel)]="orderCode"
              />
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-5 col-form-label required_label">{{
              "Bảo hành" | translate
            }}</label>
            <div class="col-12">
              <select class="form-control" formControlName="is_warranty">
                <option [value]="true">{{ "Có" | translate }}</option>
                <option [value]="false">{{ "Không" | translate }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            [disabled]="!orderCode"
            type="submit"
            class="btn btn-primary btn-lg"
            style="width: 150px"
          >
            {{ "Cập nhật" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #updateOrderType role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Cập nhật loại đơn</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="updateOrderTypeHandle()" [formGroup]="formData">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-5 col-form-label required_label">{{
              "Loại đơn mới" | translate
            }}</label>
            <div class="col-12">
              <select
                class="form-control"
                formControlName="orderType"
                [ngClass]="{ 'is-invalid': submitted && form.orderType.errors }"
                [(ngModel)]="orderType"
              >
                <option value="" disabled selected>Chọn loại đơn</option>
                <option value="new">Đơn mới</option>
                <option value="change">Đơn đổi</option>
                <option value="merge">Đơn gộp cửa hàng</option>
                <option value="separate">Đơn tách cửa hàng</option>
              </select>
            </div>
          </div>
        </div>
        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            [disabled]="!orderType"
            type="submit"
            class="btn btn-primary btn-lg"
            style="width: 150px"
          >
            {{ "Cập nhật" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #contentQR role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Hiển thị QR</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form [formGroup]="formData">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Serial" | translate
            }}</label>
            <div class="col-md-10">
              <input
                disabled
                type="text"
                class="form-control"
                formControlName="serial_number"
                [ngClass]="{
                  'is-invalid': submitted && form.serial_number.errors
                }"
              />
            </div>
          </div>
          <div class="form-group row col-md-12">
            <div class="col-md-12 d-block justify-content-center">
              <div class="d-flex justify-content-center">
                <div
                  class="borderQR d-flex flex-column align-items-center"
                  *ngIf="flagDownQr"
                  #qrContainer
                >
                  <div class="qr-with-text canvas-container">
                    <qr-code
                      class="custom-qr-code"
                      [value]="qrCodeValue"
                      [size]="400"
                      [errorCorrectionLevel]="'M'"
                    >
                    </qr-code>
                    <div class="text-center user-info" *ngIf="flagDownQr">
                      <h3
                        class="account-name"
                        [ngClass]="{
                          'long-name':
                            data?.terminal_bank_acc_name?.length > 25,
                          'very-long-name':
                            data?.terminal_bank_acc_name?.length > 35
                        }"
                      >
                        {{ data?.terminal_bank_acc_name }}
                      </h3>

                      <h3
                        class="account-number"
                        [ngClass]="{
                          'long-name':
                            data?.terminal_bank_acc_name?.length > 25,
                          'very-long-name':
                            data?.terminal_bank_acc_name?.length > 35
                        }"
                      >
                        {{ data?.terminal_bank_acc }}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center mt-3">
                <div class="col-12 col-md-3 p-0">
                  <button class="btn-viettel col" (click)="downloadQRCode()">
                    <span class="m-auto">Tải xuống mã QR</span>
                  </button>
                  <button class="btn-viettel col mt-2" (click)="printQRCode()">
                    In QR Code
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #contentCancel role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Hủy dịch vụ</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form #deleteForm="ngForm" (ngSubmit)="onDelete()" novalidate>
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-5 col-form-label required_label">{{
              "Loại huỷ" | translate
            }}</label>
            <div class="col-12">
              <select
                class="form-control"
                [ngModelOptions]="{ standalone: true }"
                [(ngModel)]="cancelType"
              >
                <option value="cancel_package">Huỷ đổi gói dịch vụ</option>
                <option value="wrong_info">
                  Huỷ do nhầm thông tin đăng ký dịch vụ
                </option>
                <option value="no_demand">
                  Huỷ do KH không có nhu cầu sử dụng dịch vụ
                </option>
                <option value="store_split">Huỷ tách cửa hàng</option>
                <option value="other">Khác</option>
              </select>
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-md-5 col-form-label required_label">
              {{ "Lý do hủy" | translate }}
            </label>
            <div class="col-12">
              <input
                placeholder="Nhập lý do hủy"
                type="text"
                [ngModelOptions]="{ standalone: true }"
                class="form-control"
                name="reasonDelete"
                [(ngModel)]="reasonDelete"
                required
                #reasonInput="ngModel"
                [ngClass]="{ 'is-invalid': submitted && reasonInput.invalid }"
              />
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-md-5 col-form-label required_label">
              Ngày KH yêu cầu hủy
            </label>
            <div class="col-12">
              <div class="input-group">
                <input
                  ngbDatepicker
                  [ngModelOptions]="{ standalone: true }"
                  class="form-control"
                  name="requestedCancelDate"
                  [(ngModel)]="requestedCancelDate"
                  [maxDate]="maxRequestedCancelDate"
                  placeholder="DD/MM/YYYY"
                  (input)="onRequestedCancelDateInput($event)"
                  required
                  #requestedCancelDatePicker="ngbDatepicker"
                  #requestedCancelDateInput="ngModel"
                  [ngClass]="{
                    'is-invalid': submitted && requestedCancelDateInput.invalid
                  }"
                />
                <div
                  class="input-group-append"
                  (click)="requestedCancelDatePicker.toggle()"
                >
                  <span class="input-group-text">
                    <i class="mdi mdi-calendar"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>

          <button
            type="submit"
            class="btn btn-danger btn-lg"
            style="width: 150px"
            [disabled]="
              reasonInput.invalid ||
              requestedCancelDateInput.invalid ||
              !cancelType
            "
          >
            {{ "Hủy đơn" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #detailOrder role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Chi tiết vận chuyển đơn hàng</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="table-responsive">
    <table
      id="basic-datatable"
      class="table table-bordered dt-responsive nowrap no-footer dtr-inline"
    >
      <thead>
        <tr class="text-center bg-table">
          <th>{{ "#" | translate }}</th>
          <!-- <th>{{'Mã đơn' | translate}}</th> -->
          <th>{{ "Địa điểm" | translate }}</th>
          <th>{{ "Trạng thái" | translate }}</th>
          <th>{{ "Thời gian" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="text-center"
          *ngFor="let data2 of dataHistory; let i = index"
        >
          <td>{{ pageSize * (pageIndex - 1) + i + 1 }}</td>
          <td>
            {{ data2.ware_house ? data2.ware_house : data2.localion_currently }}
          </td>
          <td>{{ data2.status ? data2.status : data2.status_name }}</td>
          <td>
            {{ data2.created_at ? data2.created_at : data2.order_statusdate }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>

<ng-template #renewHistory role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Lịch sử đăng ký gói dịch vụ</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="table-responsive p-4">
    <div class="package-history mt-2">
      <div
        *ngFor="let item of listData"
        class="package-history-item"
        (click)="setDetail(item)"
        [ngClass]="{
          'active-border':
            item?.device_sub_renew_id == packageDetail?.device_sub_renew_id
        }"
      >
        <div class="d-flex justify-content-between">
          <div>
            <div class="package-info">
              <div class="package registered">
                <span class="dot"></span>
                <span class="text-package">Gói đăng ký: </span
                ><span class="info">{{ item?.original_duration }} tháng</span>
              </div>
              <div class="time-range">
                {{ item?.activation_date }} - {{ item?.registeredEnd }}
              </div>
            </div>

            <div *ngIf="item?.bonus_months" class="package-info">
              <div class="package gifted">
                <span class="dot"></span>
                <span class="text-package">Thời gian tặng thêm: </span
                ><span class="info">{{ item?.bonus_months }} tháng</span>
              </div>
              <div class="time-range">
                {{ item?.giftedStart }} - {{ item?.expiration_date }}
              </div>
            </div>
          </div>
          <div>
            <span
              *ngIf="item?.status == 'Pending'"
              class="badge text-bg-danger"
            >
              <i class="bi bi-circle-fill" style="font-size: 8px"></i> Mới đăng
              kí
            </span>
            <span
              *ngIf="item?.status == 'Active'"
              class="badge text-bg-success"
            >
              <i class="bi bi-circle-fill" style="font-size: 8px"></i> Đang sử
              dụng
            </span>
            <span
              *ngIf="item?.status == 'Expired'"
              class="badge text-bg-secondary"
            >
              <i class="bi bi-circle-fill" style="font-size: 8px"></i> Hết hạn
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!listData || listData.length === 0" class="text-center p-3 text-muted">
    Chưa có dữ liệu
  </div>
  <!-- <div class="service-header-2">
    <div class="d-flex justify-content-between align-items-center">
      <div class="time-usage">Lịch sử đăng ký gói dịch vụ</div>
    </div>
    <div class="package-history mt-2">
      <div
        *ngFor="let item of listData"
        class="package-history-item"
        (click)="setDetail(item)"
        [ngClass]="{
          'active-border':
            item?.device_sub_renew_id == packageDetail?.device_sub_renew_id
        }"
      >
        <div class="d-flex justify-content-between">
          <div>
            <div class="package-info">
              <div class="package registered">
                <span class="dot"></span>
                <span class="text-package">Gói đăng ký: </span
                ><span class="info">{{ item?.original_duration }} tháng</span>
              </div>
              <div class="time-range">
                {{ item?.activation_date }} - {{ item?.registeredEnd }}
              </div>
            </div>

            <div *ngIf="item?.bonus_months" class="package-info">
              <div class="package gifted">
                <span class="dot"></span>
                <span class="text-package">Thời gian tặng thêm: </span
                ><span class="info">{{ item?.bonus_months }} tháng</span>
              </div>
              <div class="time-range">
                {{ item?.giftedStart }} - {{ item?.expiration_date }}
              </div>
            </div>
          </div>
          <div>
            <span
              *ngIf="item?.status == 'Pending'"
              class="badge text-bg-danger"
            >
              <i class="bi bi-circle-fill" style="font-size: 8px"></i> Mới
              đăng kí
            </span>
            <span
              *ngIf="item?.status == 'Active'"
              class="badge text-bg-success"
            >
              <i class="bi bi-circle-fill" style="font-size: 8px"></i> Đang sử
              dụng
            </span>
            <span
              *ngIf="item?.status == 'Expired'"
              class="badge text-bg-secondary"
            >
              <i class="bi bi-circle-fill" style="font-size: 8px"></i> Hết hạn
            </span>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</ng-template>

<ng-template #pairDevice role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Liên kết thiết bị</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="pairDevices()" [formGroup]="formData">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-5 col-form-label required_label">{{
              "Mã thiết bị" | translate
            }}</label>
            <div class="col-12">
              <ng-select
                [items]="listDeviceLink"
                bindLabel="serial_number"
                bindValue="serial_number"
                formControlName="serial_number"
                [searchable]="true"
                (search)="onSearchChange($event)"
                placeholder="{{ 'Chọn thiết bị' | translate }}"
                [ngClass]="{
                  'is-invalid': submitted && form.serial_number.errors
                }"
              >
              </ng-select>
            </div>
          </div>
        </div>
        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            type="submit"
            class="btn btn-primary btn-lg"
            style="width: 150px"
          >
            {{ "Cập nhật" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #handleOrder role="document" let-modal="close">
  <div class="modal-body">
    <p class="fw-bold mb-3">Chọn thao tác</p>
    <ul class="list-group">
      <!-- Delivery role -->
      <li
        *ngIf="role == 'delivery'"
        class="list-group-item list-group-item-action"
        (click)="onUpdate(data, updatecontent)"
      >
        📞 Cập nhật cuộc gọi
      </li>
      <li
        *ngIf="role == 'delivery'"
        class="list-group-item list-group-item-action"
        (click)="onChangeOnline(data, changeToOnline)"
      >
        🔄 Cập nhật thông tin giao hàng
      </li>
      <li
        *ngIf="role == 'delivery'"
        class="list-group-item list-group-item-action"
        (click)="onChange(data, updateOrderCode)"
      >
        🆔 Cập nhật mã đơn hàng
      </li>
      <li
        *ngIf="role == 'delivery'"
        class="list-group-item list-group-item-action"
        (click)="onChangeOrderType(data, updateOrderType)"
      >
        📝 Cập nhật loại đơn
      </li>
      <li
        *ngIf="role == 'delivery' && !data.oc_id"
        class="list-group-item list-group-item-action text-danger"
        (click)="onCancelOrder(data, contentCancel)"
      >
        ❌ Hủy dịch vụ
      </li>
      <!-- Operation / Admin / Customer service -->
      <li
        *ngIf="
          role == 'operation' || role == 'admin' || role == 'customer service'
        "
        class="list-group-item list-group-item-action text-danger"
        (click)="onChangeTime(data)"
      >
        ⏳ Thêm 1 tháng sử dụng
      </li>

      <li
        class="list-group-item list-group-item-action"
        (click)="onUpdate(data, updateCSKH)"
      >
        <i class="mdi mdi-headset mr-2"></i> Cập nhật CSKH hỗ trợ
      </li>
      <li
        *ngIf="
          data.delivery_method == 'shipper' &&
          (role == 'delivery' || role == 'admin' || role == 'customer service')
        "
        class="list-group-item list-group-item-action text-danger"
        (click)="onChange(data, updateOrderDelivered)"
      >
        🚚 Cập nhật Đã giao hàng
      </li>
      <li
        *ngIf="
          role == 'operation' || role == 'admin' || role == 'customer service'
        "
        class="list-group-item list-group-item-action"
        (click)="onUpdate(data, updatecontent)"
      >
        📞 Cập nhật cuộc gọi
      </li>
      <li
        *ngIf="
          role == 'operation' || role == 'admin' || role == 'customer service'
        "
        class="list-group-item list-group-item-action"
        (click)="onChangeOnline(data, changeToOnline)"
      >
        🔄 Cập nhật thông tin giao hàng
      </li>
      <li
        *ngIf="
          role == 'operation' || role == 'admin' || role == 'customer service'
        "
        class="list-group-item list-group-item-action"
        (click)="onChange(data, updateOrderCode)"
      >
        🆔 Cập nhật mã vận đơn
      </li>
      <li
        *ngIf="role == 'admin' || role == 'customer service'"
        class="list-group-item list-group-item-action"
        (click)="onChangeOrderType(data, updateOrderType)"
      >
        📝 Cập nhật loại đơn
      </li>
      <li
        *ngIf="(!data.oc_id && role == 'admin') || role == 'customer service'"
        class="list-group-item list-group-item-action text-danger"
        (click)="onCancelOrder(data, contentCancel)"
      >
        ❌ Hủy dịch vụ
      </li>
    </ul>
  </div>
</ng-template>

<ng-template #changeSimcard role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">
      {{ "Thay đổi mã SIM" | translate }}
    </h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="changeSim()" [formGroup]="formData">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Mã sim" | translate
            }}</label>
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="sim4g_imsi"
              />
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Nhà mạng" | translate
            }}</label>
            <div class="col-md-10">
              <ng-select
                [items]="['Viettel', 'Vinaphone', 'Mobifone']"
                formControlName="network_provider"
                placeholder="{{ 'Chọn nhà mạng' | translate }}"
                [ngClass]="{
                  'is-invalid': submitted && form.network_provider.errors
                }"
              >
              </ng-select>
            </div>
          </div>
        </div>
        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            type="submit"
            class="btn btn-success btn-lg"
            style="width: 150px"
          >
            {{ "Lưu" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #cumulativeServicePackage role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">
      {{ "Cộng dồn gói dịch vụ" | translate }}
    </h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="cumulativeSP()" [formGroup]="formData">
        <div class="row">
          <!-- Số điện thoại -->
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">
              {{ "Số điện thoại KH" | translate }}
            </label>
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                disabled
                [ngModel]="phone"
                [ngModelOptions]="{ standalone: true }"
                placeholder="Nhập số điện thoại khách hàng"
              />
              <div
                *ngIf="submitted && formData.get('phone').errors"
                class="text-danger"
              >
                Vui lòng nhập số điện thoại hợp lệ
              </div>
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">
              {{ "Mã thiết bị mới" | translate }}
            </label>
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                disabled
                formControlName="serial_number"
                placeholder="Nhập mã thiết bị mới"
              />
              <div
                *ngIf="submitted && formData.get('serial_number').errors"
                class="text-danger"
              >
                Vui lòng nhập mã thiết bị mới
              </div>
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">
              {{ "Mã thiết bị cũ" | translate }}
            </label>
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="serial_number_old"
                placeholder="Nhập mã thiết bị cũ"
              />
              <div
                *ngIf="submitted && formData.get('serial_number_old').errors"
                class="text-danger"
              >
                Vui lòng nhập mã thiết bị cũ
              </div>
            </div>
          </div>
        </div>

        <!-- Action buttons -->
        <div class="text-center mt-3">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            type="submit"
            class="btn btn-success btn-lg"
            style="width: 150px"
          >
            {{ "Lưu" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #contentCancelDevice role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">
      {{ "Huỷ liên kết thiết bị" | translate }}
    </h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="unPairDevice()" [formGroup]="formData">
        <div class="row">
          <!-- Thiết bị -->
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Thiết bị" | translate
            }}</label>
            <div class="col-md-10">
              <input
                disabled
                type="text"
                class="form-control"
                formControlName="serial_number"
                [ngClass]="{
                  'is-invalid':
                    submitted && formData.get('serial_number')?.errors
                }"
              />
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Lý do huỷ" | translate
            }}</label>
            <div class="col-md-10">
              <ng-select
                [items]="reasonCancelDeviceList"
                bindLabel="name"
                bindValue="code"
                formControlName="reason"
                (change)="onCancelReasonChange($event)"
                placeholder="{{ 'Chọn lý do huỷ' | translate }}"
                [ngClass]="{
                  'is-invalid': submitted && formData.get('reason')?.errors
                }"
              >
              </ng-select>
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Nhập lý do chi tiết" | translate
            }}</label>
            <div class="col-md-10">
              <textarea
                class="form-control"
                rows="3"
                formControlName="note"
                placeholder="{{ 'Nhập lý do huỷ liên kết' | translate }}"
                [ngClass]="{
                  'is-invalid':
                    submitted &&
                    formData.get('reason')?.value === 'OTHER' &&
                    formData.get('note')?.errors
                }"
              ></textarea>

              <div
                class="invalid-feedback"
                *ngIf="
                  submitted &&
                  formData.get('reason')?.value === 'OTHER' &&
                  formData.get('note')?.errors
                "
              >
                {{ "Vui lòng nhập ghi chú khi chọn lý do khác" | translate }}
              </div>
            </div>
          </div>
          <div
            class="form-group row col-md-12"
            *ngIf="formData.get('reason')?.value && formData.get('reason')?.value !== 'LOST'"
          >
          <label class="col-md-2 col-form-label">
            {{ "Đã thu hồi thiết bị" | translate }}
          </label>
          <div class="col-md-10 d-flex align-items-center">
            <input
              type="checkbox"
              class="form-check-input m-0"
              [checked]="formData.get('is_recalled')?.value == 1"
              (change)="onRecalledChange($event.target.checked)"
              id="isRecalledCheckbox"
            />
          </div>
        </div>
        <ng-container *ngIf="formData.get('reason')?.value && formData.get('reason')?.value !== 'LOST' && formData.get('is_recalled')?.value === 1">
          <div class="col-md-12">
            <div class="recall-details-grid">
              <div class="recall-detail-field">
                <label class="required_label">Phân loại thiết bị</label>
                <ng-select
                  [items]="reuseCategoryOptions"
                  bindLabel="label"
                  bindValue="value"
                  formControlName="reuse_category"
                  placeholder="Chọn phân loại"
                  [ngbTooltip]="getReuseCategoryDescription(formData.get('reuse_category')?.value)"
                  [disableTooltip]="!formData.get('reuse_category')?.value"
                  container="body"
                  [ngClass]="{ 'is-invalid': submitted && formData.get('reuse_category')?.invalid }"
                >
                  <ng-template ng-option-tmp let-item="item">
                    <span [ngbTooltip]="item.description" placement="right" container="body">
                      {{ item.label }}
                    </span>
                  </ng-template>
                </ng-select>
                <div class="invalid-feedback d-block" *ngIf="submitted && formData.get('reuse_category')?.invalid">
                  Vui lòng chọn phân loại thiết bị.
                </div>
              </div>
              <div class="recall-detail-field">
                <label class="required_label">Ngày nhận hàng hoàn</label>
                <div class="input-group">
                  <input
                    ngbDatepicker
                    class="form-control"
                    formControlName="returned_date"
                    [maxDate]="maxRequestedCancelDate"
                    placeholder="DD/MM/YYYY"
                    (input)="onRequestedCancelDateInput($event)"
                    #returnedDatePicker="ngbDatepicker"
                    [ngClass]="{ 'is-invalid': submitted && formData.get('returned_date')?.invalid }"
                  />
                  <div
                    class="input-group-append"
                    (click)="returnedDatePicker.toggle()"
                  >
                    <span class="input-group-text">
                      <i class="mdi mdi-calendar"></i>
                    </span>
                  </div>
                </div>
                <div class="invalid-feedback" *ngIf="submitted && formData.get('returned_date')?.invalid">
                  Vui lòng chọn ngày nhận hàng hoàn.
                </div>
              </div>
              <div class="recall-detail-field recall-detail-field--full">
                <label class="required_label">Lý do phân loại</label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="reuse_category_reason"
                  placeholder="Nhập lý do phân loại"
                  [ngClass]="{
                    'is-invalid': submitted && formData.get('reuse_category_reason')?.invalid
                  }"
                />
                <div
                  class="invalid-feedback"
                  *ngIf="submitted && formData.get('reuse_category_reason')?.invalid"
                >
                  Vui lòng nhập lý do phân loại.
                </div>
              </div>
              <div class="recall-detail-field">
                <label class="required_label">Hình ảnh</label>
                <input type="file" class="form-control-file" accept="image/*"
                  (change)="onRecalledFileChange($event, 'recalled_image')" />
                <small class="form-text text-muted">Bắt buộc 1 ảnh, dung lượng tối đa 8MB.</small>
                <div class="invalid-feedback d-block" *ngIf="submitted && formData.get('recalled_image')?.invalid">
                  Vui lòng tải lên hình ảnh hợp lệ.
                </div>
              </div>
              <div class="recall-detail-field">
                <label class="required_label">Video</label>
                <input type="file" class="form-control-file" accept="video/*"
                  (change)="onRecalledFileChange($event, 'recalled_video')" />
                <small class="form-text text-muted">Bắt buộc 1 video, dung lượng tối đa 50MB.</small>
                <div class="invalid-feedback d-block" *ngIf="submitted && formData.get('recalled_video')?.invalid">
                  Vui lòng tải lên video hợp lệ.
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        </div>
        <!-- Nút hành động -->
        <div class="text-center mt-3">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            type="submit"
            class="btn btn-success btn-lg"
            style="width: 150px"
            [disabled]="!canSubmitUnpairDevice()"
          >
            {{ "Lưu" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #contentLink role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Gửi thông báo tới thiết bị</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="deviceCheck()" [formGroup]="formData">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Thiết bị" | translate
            }}</label>
            <div class="col-md-10">
              <input
                disabled
                type="text"
                class="form-control"
                formControlName="serial_number"
                [ngClass]="{
                  'is-invalid': submitted && form.serial_number.errors
                }"
              />
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Số tiền" | translate
            }}</label>
            <div class="col-md-10">
              <input
                placeholder="Nhập số tiền"
                type="number"
                class="form-control"
                formControlName="serial_number_new"
                [ngClass]="{
                  'is-invalid': submitted && form.serial_number_new.errors
                }"
              />
            </div>
          </div>
        </div>
        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            type="submit"
            class="btn btn-success btn-lg"
            style="width: 150px"
          >
            {{ "Gửi thông báo" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #contentSearch role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Tra cứu giao dịch</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form [formGroup]="formData">
        <div class="row">
          <div class="form-group row col-md-12">
            <div class="col-md-6">
              <label class="col-md-12 col-form-label required_label">{{
                "Mã Thiết Bị" | translate
              }}</label>
              <div class="col-md-10 mt-4">
                <input
                  disabled
                  type="text"
                  class="form-control"
                  formControlName="serial_number"
                  [ngClass]="{
                    'is-invalid': submitted && form.serial_number.errors
                  }"
                />
              </div>
            </div>
            <div class="col-md-6">
              <label class="col-md-12 col-form-label required_label">{{
                "Khoảng thời gian" | translate
              }}</label>
              <div class="col-md-10">
                <div class="form-group col-3">
                  <mat-form-field appearance="fill" class="mt-3">
                    <mat-label>Chọn khoảng ngày </mat-label>
                    <mat-date-range-input
                      [formGroup]="range"
                      [rangePicker]="picker"
                    >
                      <input
                        matStartDate
                        formControlName="start"
                        [min]="minTransactionDate"
                        placeholder="Ngày bắt đầu"
                      />
                      <input
                        matEndDate
                        formControlName="end"
                        [min]="minTransactionDate"
                        placeholder="Ngày kết thúc"
                      />
                    </mat-date-range-input>
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="picker"
                    ></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                    <mat-error
                      *ngIf="
                        range.controls.start.hasError('matStartDateInvalid')
                      "
                      >Invalid start date</mat-error
                    >
                    <mat-error
                      *ngIf="range.controls.end.hasError('matEndDateInvalid')"
                      >Invalid end date</mat-error
                    >
                  </mat-form-field>
                </div>
                <p class="text-danger font-size-10 font-italic">
                  Chọn khoảng thời gian để tra cứu
                </p>
                <button class="btn btn-success" (click)="getDataTransaction()">
                  Tra cứu
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="table-responsive">
          <table
            id="basic-datatable"
            class="table table-bordered dt-responsive nowrap no-footer dtr-inline"
          >
            <thead>
              <tr class="text-center bg-table">
                <th>{{ "#" | translate }}</th>
                <th>{{ "Cửa hàng" | translate }}</th>
                <th>{{ "Mã giao dịch" | translate }}</th>
                <th>{{ "Thiết bị" | translate }}</th>
                <th>{{ "Số tài khoản" | translate }}</th>
                <th>{{ "Số tiền" | translate }}</th>
                <th>{{ "Trạng thái" | translate }}</th>
                <th>{{ "Ngày giao dịch" | translate }}</th>
              </tr>
            </thead>
            <tbody *ngFor="let data of dataTransaction; let i = index">
              <tr>
                <td>
                  <a>{{ pageSize * (pageIndex - 1) + i + 1 }}</a>
                </td>
                <td>
                  <a>{{ data?.workspace_name }}</a>
                </td>
                <td>
                  <a>{{ data?.code }}</a>
                </td>
                <td>
                  <a>{{ data?.serial_number }}</a>
                </td>
                <td>
                  <a> {{ data.account_number }} </a>
                </td>

                <td>
                  <a>
                    {{ data?.total | number : "1.0-0" }} <sup><ins>đ</ins></sup>
                  </a>
                </td>

                <td>
                  <span
                    class="font-size-12 badge badge-danger"
                    *ngIf="data.status == '0'"
                    >{{ "Từ chối" | translate }}</span
                  >
                  <span
                    class="font-size-12 badge badge-warning"
                    *ngIf="data.status == '2'"
                    >{{ "Đang xử lý" | translate }}</span
                  >
                  <span
                    class="font-size-12 badge badge-success"
                    *ngIf="data.status == '1'"
                    >{{ "Đã thanh toán" | translate }}</span
                  >
                </td>
                <td>
                  <a>{{ data.created_at | date : "dd/MM/yyyy HH:mm" }}</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row justify-content-md-between align-items-md-center mt-2">
          <div class="col-sm-12 col-md-5">
            <div
              class="dataTables_info mb-2"
              id="tickets-table_info"
              role="status"
              aria-live="polite"
            >
              {{ "TABLE.Showing" | translate }}
              {{ pageSize * pageIndex - pageSize + 1 }}
              {{ "TABLE.to" | translate }} {{ pageSize * pageIndex }}
              {{ "TABLE.of" | translate }} {{ totalCount }}
              {{ "TABLE.entries" | translate }}
            </div>
          </div>
          <div
            class="col-sm-12 col-md-5 d-flex align-items-center justify-content-end"
          >
            <div class="text-md-right float-md-right pagination-rounded">
              <ngb-pagination
                [collectionSize]="totalCount"
                [(page)]="pageIndex"
                [pageSize]="pageSize"
                [maxSize]="5"
                [ellipses]="true"
                (pageChange)="getDataTransaction()"
              >
              </ngb-pagination>
            </div>
            <div class="dataTables_length ml-3" id="tickets-table_length">
              <label class="d-inline-flex align-items-center mb-0">
                {{ "TABLE.Show" | translate }}
                <select
                  name="tickets-table_length"
                  aria-controls="tickets-table"
                  name="pageSize"
                  [(ngModel)]="pageSize"
                  (ngModelChange)="pageIndex = 1; getDataTransaction()"
                  class="custom-select custom-select-sm form-control form-control-sm mx-2"
                >
                  <option [ngValue]="10">10</option>
                  <option [ngValue]="25">25</option>
                  <option [ngValue]="50">50</option>
                  <option [ngValue]="100">100</option>
                </select>
                {{ "TABLE.entries" | translate }}
              </label>
            </div>
          </div>
        </div>
        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #contentMarkIssue role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">{{ "Đánh dấu mất/hỏng loa" | translate }}</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <div class="row">
        <div class="form-group row col-md-12">
          <label class="col-md-3 col-form-label required_label">{{
            "Thiết bị" | translate
          }}</label>
          <div class="col-md-9">
            <input
              disabled
              type="text"
              class="form-control"
              [value]="selectedDeviceForIssue?.serial_number"
            />
          </div>
        </div>
        <div class="form-group row col-md-12">
          <label class="col-md-3 col-form-label required_label">{{
            "Loại" | translate
          }}</label>
          <div class="col-md-9">
            <select class="form-control" [(ngModel)]="deviceIssueType">
              <option value="" disabled selected>Chọn loại</option>
              <option value="lost">Mất loa</option>
              <option value="broken">Hỏng loa</option>
            </select>
          </div>
        </div>
        <div class="form-group row col-md-12">
          <label class="col-md-3 col-form-label">{{
            "Ghi chú" | translate
          }}</label>
          <div class="col-md-9">
            <textarea
              class="form-control"
              rows="3"
              [(ngModel)]="deviceIssueNote"
              placeholder="{{ 'Nhập ghi chú (nếu có)' | translate }}"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="text-center mt-3">
        <button
          type="button"
          class="btn btn-secondary btn-lg mr-3"
          style="width: 150px"
          (click)="modal('close click')"
        >
          {{ "Đóng" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-warning btn-lg"
          style="width: 150px"
          [disabled]="!deviceIssueType"
          (click)="markDeviceIssue()"
        >
          {{ "Xác nhận" | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
